import { styled } from '@mui/material'
import Typography from '@mui/material/Typography'
import { COLORS } from '../../styles/colors'

export const TypographySecondary = styled(Typography)(theme => ({
	fontWeight: 400,
	fontSize: '12px',
	lineHeight: '15px',
	color: COLORS.secondaryFont,
}))
